const MATRIX_ID_REGEX = /^@[a-zA-Z0-9._=-]+:[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const getMatrixDisplayName = (rawDisplayName: string | undefined, userId: string): string => {
  if (rawDisplayName && !MATRIX_ID_REGEX.test(rawDisplayName)) return rawDisplayName;
  return userId.split(':')[0].replace('@', '') || 'Unknown';
};
